// StepRegistry.ts — Maps wizard step IDs to metadata for the dynamic wizard shell.
// MANUS-WIZARD-V2 Task 3. Step rendering is delegated to WizardPage's renderStep callback.
import type { WizardStep } from '../../lib/path-matrix';

export interface StepMeta {
  id: WizardStep;
  label: string;
  required: boolean;
}

/**
 * Registry of all wizard steps with their metadata.
 * The WizardShell uses this to render the progress bar and step labels.
 * Actual component rendering is handled by the parent's renderStep callback,
 * because the step components are inline closures that capture parent state.
 */
export const STEP_REGISTRY: Record<WizardStep, StepMeta> = {
  github: { id: 'github', label: 'GitHub', required: true },
  railway: { id: 'railway', label: 'Railway', required: false },
  deploy_config: { id: 'deploy_config', label: 'Deploy Config', required: false },
  supabase: { id: 'supabase', label: 'Supabase', required: false },
  mailgun: { id: 'mailgun', label: 'Mailgun', required: false },
  netlify: { id: 'netlify', label: 'Netlify', required: false },
  stripe: { id: 'stripe', label: 'Stripe', required: false },
  deploy_verify: { id: 'deploy_verify', label: 'Deploy & Verify', required: false },
};

/** Get the StepMeta for a given step, with a fallback for unknown steps. */
export function getStepMeta(step: WizardStep): StepMeta {
  return STEP_REGISTRY[step] ?? { id: step, label: step, required: false };
}
